import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import articleRouter from './modules/article.js';

export const constantRoutes = [
    articleRouter,
    {
        path: '/rangeSearchCase',
        component: () =>
            import('@/pages/retrieveProjectSritNew/views/rangeSearch/caseGit.vue'),
        name: 'rangeSearchCase',
    },
    {
        path: '/aiSearch',
        component: () =>
            import('@/pages/retrieveProjectSritNew/views/aiSearch/index.vue'),
        name: 'aiSearch',
    },
    // 添加首页路由（如果还没有）
    {
        path: '/',
        component: () =>
            import('@/pages/retrieveProjectSritNew/views/homePage/home.vue'), // 替换为你的首页组件路径
        name: 'Home',
    },
    // 重定向所有未匹配的路由到首页
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/simpleSearch',
        component: () =>
            import('@/pages/retrieveProjectSritNew/views/simpleSearchPage/simpleSearch.vue'),
        name: 'simpleSearch',
    },
];
const createRouter = () =>
    new VueRouter({
        mode: 'history', // require service support
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes,
    });

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}
export default router;